export default "__VITE_ASSET__BGbuNm2W__"